import { render, staticRenderFns } from "./TenantSystemPrefsForm.vue?vue&type=template&id=94957e8c&scoped=true"
import script from "./TenantSystemPrefsForm.vue?vue&type=script&lang=ts"
export * from "./TenantSystemPrefsForm.vue?vue&type=script&lang=ts"
import style0 from "./TenantSystemPrefsForm.vue?vue&type=style&index=0&id=94957e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94957e8c",
  null
  
)

export default component.exports